import i18next from "i18next"
import {
  MESSAGE_CODE_CROSS_COUNTRY_SUBSIDY_CANNOT_BE_CHANGED,
  MESSAGE_CODE_ORDER_MODIFICATION_CANNNOT_SELECT_SUBSIDY_COUNTRY,
  salesMessageCodeMap,
} from "modules/messageCodeSales"
import { PAYMENT_TYPE_ONLINE_CREDIT_CARD } from "modules/payment"
import { call, fork, put, select, takeEvery } from "redux-saga/effects"
import * as fetchApi from "services/api/fetchApi"
import { getGlobalUi, globalUiAction } from "services/globalUi"
import { getScooter } from "services/scooter"
import { getUserState } from "services/userState"
import { supported, webStorage } from "services/utils"
import Cookies from "universal-cookie"
import { FEDERATION_GLB } from "views/constants/jsonData/globalData"

import { orderScooterAction } from "./action"
import { getOrderScooter } from "./selector"
import { formatPersonalData, formatPostData, getModifyData, initPersonalData } from "./util"

const cookies = new Cookies()

function* fetchCheckoutData({ payload }) {
  const globalUi = yield select(getGlobalUi)
  const orderScooter = yield select(getOrderScooter)
  let modifyResponse = null

  if (orderScooter.ShoppingCartData) {
    yield put(globalUiAction.setGlobalUI({ isLoading: true }))
  }

  try {
    if (payload.orderNo) {
      // order/modify
      modifyResponse = yield call(
        fetchApi.getDataByFetch,
        `/${globalUi.langCode}/api/order-form/get-order-data/${payload.orderNo}`,
      )
      if (modifyResponse.data.Result === 0) {
        yield put(
          globalUiAction.openErrorModal({
            title: i18next.t("sales:message.title_get_shopping_cart_data_fail"),
            content: `${modifyResponse.data.MessageCode}, ${modifyResponse.data.Message}`,
          }),
        )
      }
    }
    const response = yield call(
      fetchApi.getDataByFetch,
      `/${globalUi.langCode}/api/order-form/get-checkout-data/${payload.bag}`,
    )

    if (response.data.Result === 1) {
      let initData = {}

      if (payload.orderNo) {
        // order/modify
        if (modifyResponse && modifyResponse.data.Result === 1) {
          // order/modify
          initData = getModifyData(response.data.Data, modifyResponse.data.Data, payload.winner)
          yield put(orderScooterAction.setOrderUIState({ ...initData, replyOrderData: true }))
        }
      } else {
        initData = response.data.Data
        const globalUi = yield select(getGlobalUi)
        const initUser = globalUi.orderUserData || webStorage.getSs("orderUserData")
        const birthday = new Date(initUser?.Birthday)

        initData.currentPath = "scooter"
        // 法人贈車 0
        initData.UserData = initUser && initUser !== "0" ? formatPersonalData(initUser, birthday) : initPersonalData

        initData.currentScooter = initData.ShoppingCartData.Product.find((group) => group.Type === 0).Product
        const scooterProduct = initData.currentScooter.find((item) => item.Type === 1)

        initData.remaining = {
          licenseType: initData.ShoppingCartData.ScooterLicenseType,
          scooterProductNo: scooterProduct && scooterProduct.ProductNo,
        }

        initData.isCrossCityIssueInvoice = null
        initData.companyIdentity = null

        yield put(orderScooterAction.setOrderUIState({ ...initData, replyOrderData: true }))
      }
    } else {
      throw {
        // eslint-disable-line no-throw-literal
        name: response.data.MessageCode,
        message: response.data.Message,
      }
    }
  } catch (error) {
    yield put(
      globalUiAction.openErrorModal({
        title: i18next.t("sales:message.title_get_shopping_cart_data_fail"),
        content: `${error.name}, ${error.message}`,
      }),
    )
  } finally {
    if (payload.orderNo) {
      yield put(orderScooterAction.getFormatPostData("initPostData", payload.orderNo))
    }

    yield put(orderScooterAction.getInitPaymentData())

    if (globalUi.orderScooterInit || orderScooter.ShoppingCartData) {
      yield put(globalUiAction.setGlobalUI({ isLoading: false }))
    }
  }
}

function* orderScooterCheckout({ payload }) {
  const globalUi = yield select(getGlobalUi)
  const userState = yield select(getUserState)
  const orderScooter = yield select(getOrderScooter)
  const scooter = yield select(getScooter)

  try {
    const postData = yield call(formatPostData, userState, globalUi, orderScooter, scooter)
    yield put(orderScooterAction.setFormData("postData", postData))

    const response = yield call(fetchApi.postDataByFetch, `/${globalUi.langCode}/api/shopping-cart/checkout`, postData)

    // PH 環境的付款方式
    const isPhPaymentMethod =
      postData.Payment.Type === PAYMENT_TYPE_ONLINE_CREDIT_CARD && userState.userData.Federation === FEDERATION_GLB

    if (response.data.Result === 1) {
      cookies.remove("orderUserData")

      const { OrderNo } = response.data.Data

      // 判斷是否為線上付款
      if (isPhPaymentMethod) {
        const onlinePaymentResult = yield call(
          fetchApi.getDataByFetch,
          `/${globalUi.langCode}/api/online-payment/get-payment-key?orderNo=${OrderNo}`,
        )
        if (onlinePaymentResult.data.Result === 1) {
          window.location.href = onlinePaymentResult.data.Data.PaymentRedirectUrl
        } else {
          throw {
            // eslint-disable-line no-throw-literal
            name: onlinePaymentResult.data.MessageCode,
            message: onlinePaymentResult.data.Message,
            OrderNo: OrderNo,
          }
        }
      } else {
        yield call(payload.resolve, OrderNo)
      }
    } else {
      throw {
        // eslint-disable-line no-throw-literal
        name: response.data.MessageCode,
        message: response.data.Message,
        messageCodeParams: response.data.MessageCodeParams,
      }
    }
  } catch (error) {
    const errorCode = salesMessageCodeMap.get(parseInt(error.name, 10)) ?? "system_is_busy"
    yield put(
      globalUiAction.openErrorModal({
        title: i18next.t("sales:message.title_transaction_fail_please_try_again"),
        content: error.name ? i18next.t(`sales:message.${errorCode}`, error?.messageCodeParams) : "",
        callback: (confirmed) => {
          if (confirmed && error?.OrderNo) {
            window.location.href = `/order/${error.OrderNo}/modify`
          }
        },
      }),
    )
  } finally {
    yield put(globalUiAction.setGlobalUI({ isLoading: false }))
  }
}

function* getFormatPostData({ payload }) {
  try {
    const globalUi = yield select(getGlobalUi)
    const userState = yield select(getUserState)
    const orderScooter = yield select(getOrderScooter)
    const postData = yield call(formatPostData, userState, globalUi, orderScooter)
    postData.OrderNo = payload.orderNo ? payload.orderNo : null
    yield put(orderScooterAction.setOrderUIState({ [`${payload.name}`]: JSON.parse(JSON.stringify(postData)) }))
  } catch (error) {
    console.log(error)
  }
}

function* getInitPaymentData() {
  try {
    const orderScooter = yield select(getOrderScooter)
    yield put(orderScooterAction.setOrderUIState({ initPaymentData: orderScooter.allFormData.PaymentInfo }))
  } catch (error) {
    console.log(error)
  }
}

function* orderModifyCheckout({ payload }) {
  try {
    const globalUi = yield select(getGlobalUi)
    const userState = yield select(getUserState)
    const orderScooter = yield select(getOrderScooter)
    const currentData = yield call(formatPostData, userState, globalUi, orderScooter)
    const diffData = yield call(
      supported.ObjectCompare.createNew().getDiff,
      orderScooter.initPostData,
      currentData,
      true,
    )

    Object.keys(diffData).forEach((key) => {
      if (diffData[key] === -1) {
        diffData[key] = currentData[key]
      }
    })
    diffData.OrderNo = orderScooter.orderNo
    diffData.ProductList = orderScooter.ShoppingCartData.Product
    diffData.Promotion = currentData.Promotion
    diffData.Coupon = currentData.Coupon
    diffData.Discount = currentData.Discount
    diffData.Payment = currentData.Payment // 讓付款資料補回來
    diffData.Owner = currentData.Owner
    diffData.Driver = currentData.Driver
    diffData.Scooter.Licensing.LicensingLocationId = currentData.Scooter.Licensing.LicensingLocationId
    diffData.Scooter.Licensing.LicensingLocation = currentData.Scooter.Licensing.LicensingLocation
    diffData.Scooter.Licensing.PickNumberType = currentData.Scooter.Licensing.PickNumberType
    diffData.Scooter.Licensing.PickNumberRemark = currentData.Scooter.Licensing.PickNumberRemark
    diffData.Scooter.LicenseType = currentData.Scooter.LicenseType
    if (currentData.Scooter.Subsidy) {
      diffData.Scooter.Subsidy = currentData.Scooter.Subsidy
    }
    diffData.SalesChannelNo = currentData.SalesChannelNo
    diffData.SalesStoreName = currentData.SalesStoreName
    diffData.SalesStoreNo = currentData.SalesStoreNo
    diffData.ProjectActivity = currentData.ProjectActivity
    diffData.UBIAgree = currentData.UBIAgree
    diffData.UBIContact1 = currentData.UBIContact1
    diffData.UBIContact2 = currentData.UBIContact2
    diffData.UBIDescription1 = currentData.UBIDescription1
    diffData.UBIDescription2 = currentData.UBIDescription2
    diffData.Scooter.Vin = orderScooter.remaining.vin

    const response = yield call(
      fetchApi.postDataByFetch,
      `/${globalUi.langCode}/api/shopping-cart/modify-order`,
      diffData,
    )

    // PH 環境的付款方式
    const isPhPaymentMethod =
      diffData.Payment.Type === PAYMENT_TYPE_ONLINE_CREDIT_CARD && userState.userData.Federation === FEDERATION_GLB

    if (response.data.Result === 1) {
      const { IsScooterChange: scooterChanged, OrderNo } = response.data.Data

      // 判斷是否為線上付款
      if (isPhPaymentMethod) {
        const onlinePaymentResult = yield call(
          fetchApi.getDataByFetch,
          `/${globalUi.langCode}/api/online-payment/get-payment-key?orderNo=${OrderNo}`,
        )
        if (onlinePaymentResult.data.Result === 1) {
          window.location.href = onlinePaymentResult.data.Data.PaymentRedirectUrl
        } else {
          throw {
            // eslint-disable-line no-throw-literal
            status: onlinePaymentResult.data.MessageCode,
            statusText: onlinePaymentResult.data.Message,
          }
        }
      } else {
        yield call(payload.resolve, scooterChanged)
      }
    } else {
      throw {
        // eslint-disable-line no-throw-literal
        status: response.data.MessageCode,
        statusText: response.data.Message,
      }
    }
  } catch (error) {
    const orderScooter = yield select(getOrderScooter)

    const errorCode = parseInt(error.status, 10)

    if (errorCode === MESSAGE_CODE_CROSS_COUNTRY_SUBSIDY_CANNOT_BE_CHANGED) {
      yield put(
        globalUiAction.openErrorModal({
          name: i18next.t("sales:message.dialog.title.edit_order"),
          title: i18next.t("sales:message.title_cross_county_subsidy_cannot_be_changed"),
          content: i18next.t(`sales:message.cross_country_subsidy_cannot_be_changed`),
          okayLabel: i18next.t("label:try_again"),
        }),
      )
    } else if (errorCode === MESSAGE_CODE_ORDER_MODIFICATION_CANNNOT_SELECT_SUBSIDY_COUNTRY) {
      yield put(
        globalUiAction.openErrorModal({
          name: i18next.t("sales:message.dialog.title.edit_order"),
          title: i18next.t("sales:message.title_order_modification_cannot_select_subsidy_country"),
          content: i18next.t(`sales:message.cross_country_subsidy_cannot_be_changed`),
          okayLabel: i18next.t("label:try_again"),
        }),
      )
    } else {
      const errorMessage = salesMessageCodeMap.get(errorCode)
        ? i18next.t(`sales:message.${salesMessageCodeMap.get(errorCode)}`)
        : i18next.t("sales:message.system_is_busy")

      yield put(
        globalUiAction.openErrorModal({
          name: i18next.t("sales:message.dialog.title.edit_order"),
          title: i18next.t("sales:message.dialog.title.unable_edit_order"),
          content: errorMessage,
          okayLabel: i18next.t("label:okay"),
        }),
      )
    }

    yield put(orderScooterAction.setFormData("PaymentInfo", orderScooter.initPaymentData))
  } finally {
    yield put(globalUiAction.setGlobalUI({ isLoading: false }))
  }
}

function* modifyShoppingCartData({ payload }) {
  try {
    yield put(orderScooterAction.setOrderUIState({ ShoppingCartData: payload }))
  } catch (error) {
    console.log(error)
  }
}

function* getPDIStoreOptions() {
  try {
    const response = yield call(fetchApi.getDataByFetch, `/tw/api/order-form/get-store/0`)
    yield put(orderScooterAction.setOrderUIState({ PDIStoreOptions: response?.data?.Data }))
  } catch (error) {
    console.log(error)
  }
}

//=====================================
//  WATCHERS
//-------------------------------------

export function* watchGetCheckoutData() {
  yield takeEvery(orderScooterAction.FETCH_CHECKOUT_DATA, fetchCheckoutData)
}

export function* watchOrderScooterCheckout() {
  yield takeEvery(orderScooterAction.ORDER_SCOOTER_CHECKOUT, orderScooterCheckout)
}

export function* watchGetFormatPostData() {
  yield takeEvery(orderScooterAction.GET_FORM_POST_DATA, getFormatPostData)
}

export function* watchGetPaymentInitData() {
  yield takeEvery(orderScooterAction.GET_PAYMENT_INIT_DATA, getInitPaymentData)
}

export function* watchOrderModifyCheckout() {
  yield takeEvery(orderScooterAction.ORDER_MODIFY_CHECKOUT, orderModifyCheckout)
}

export function* watchModifyShoppingCartData() {
  yield takeEvery(orderScooterAction.MODIFY_SHOPPINGCART_DATA, modifyShoppingCartData)
}

export function* watchGetPDIStoreOptions() {
  yield takeEvery(orderScooterAction.GET_PDISTORE_OPTIONS, getPDIStoreOptions)
}
//=====================================
//  ROOT
//-------------------------------------

export const orderScooterSaga = [
  fork(watchGetCheckoutData),
  fork(watchOrderScooterCheckout),
  fork(watchGetFormatPostData),
  fork(watchGetPaymentInitData),
  fork(watchOrderModifyCheckout),
  fork(watchModifyShoppingCartData),
  fork(watchGetPDIStoreOptions),
]
